module.exports = __webpack_public_path__ + "img/image-01.41ff7741.webp";